// extracted by mini-css-extract-plugin
export default {"backIconColor":"#44cc94","column":"column__2-j3o","row":"row__3wR57","headerTitle":"headerTitle__2wbOc","paymentMethodsContent":"paymentMethodsContent__3jZI2","priceInfos":"priceInfos__1Lz3n","mainPrice":"mainPrice__2XO-W","price":"price__y3pHx","description":"description__3TsW3","paymentButton":"paymentButton__2l_iF","previousButton":"previousButton__2Bvbc"};
    if(module.hot) {
      // 1713425460609
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  